import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import slick from "slick-carousel/slick/slick.min.js";
import slickCss from "slick-carousel/slick/slick.css";
import slickTheme from "slick-carousel/slick/slick-theme.css";
import modaal from 'modaal';
import modaalCss from "modaal/dist/css/modaal.scss";


import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"



class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

      //SPメニューの高さ取得
    function menuHight() {
        var win = $(window).innerWidth();
        if (win > 750) {
            return false;
        }

        var $smpHeaderHeight = $('.l-header').height();
        var windowHeight = window.innerHeight;
        var winH = windowHeight - $smpHeaderHeight;

        console.log($smpHeaderHeight);

        //動かすターゲットを取得
        var targetSlidebarWrap = $('.c-slidebar-menu'),
            targetSlidebarMenu = $('.c-slidebar__parent'),
            targetSlidebarBtn = $('.c-slidebar-menu__parent');


        //いざ実行(クリックしたら処理を実行する)
        targetSlidebarBtn.on('click', function () {
            $('.c-slidebar-menu').toggleClass('is-active');

        });
    }

      //フッターメニューSPスライド
      function menuSlide() {
          var win = $(window).innerWidth();
          if (win > 750) {
              return false;
          }
          $('.l-footer__block').on('click',function() {
              $(this).children(".l-footer__menutitle").toggleClass('is-open');
              $(this).children(".l-footer__menulist.is-sub").slideToggle();
          })
      }
      //owlcarousel
      function owlCarousel() {
          var owls = $('.owl-carousel');
          if (owls.length === 0) {
              return false
          }
          //->スライダー
          owls.imagesLoaded(function () {
              $('.c-main-visual__slider').owlCarousel({
                  items: 1,
                  margin: 0,
                  dots: true,
                  loop: true,
                  nav: false,
                  autoplayHoverPause: true,
                  autoplay: true,
                  autoplaySpeed: 500,
                  autoWidth: false,
                  autoHeight: false,
                  center: true,
                  navText: ['<img src="/wp-content/themes/ogura-enfant-html/dist/assets/images/icon-slider-prev.svg" />','<img src="/wp-content/themes/ogura-enfant-html/dist/assets/images/icon-slider-next.svg" />'],
              });
          });
          //->カルーセル
          owls.imagesLoaded(function () {
              $('.c-main-visual__carousel').owlCarousel({
                  items: 1,
                  margin: 16,
                  dots: true,
                  loop: true,
                  nav: true,
                  autoplayHoverPause: true,
                  autoplay: false,
                  autoplaySpeed: 500,
                  autoWidth: false,
                  autoHeight: false,
                  center: true,
                  navText: ['<div class="c-main-visual__nav is-left"><i class="fa fa-angle-left" aria-hidden="true"></i></div>','<div class="c-main-visual__nav is-right"><i class="fa fa-angle-right" aria-hidden="true"></i></div>'],
                  responsive : {
                    // breakpoint from 0 up
                    0 : {
                      stagePadding: 32,
                    },
                    // breakpoint from 750  up
                    750 : {
                      stagePadding: 64,
                    },
                    // breakpoint from 950 up
                    950 : {
                      stagePadding: 156,
                    },
                    1400 : {
                      stagePadding: 312,
                    }
                  }
              });
          });
          //->カルーセル_ノーマル
          owls.imagesLoaded(function () {
          $('.c-main-visual__carousel.is-normal').owlCarousel({
            items: 1,
            margin: 8,
            dots: true,
            loop: true,
            nav: true,
            autoplayHoverPause: true,
            autoplay: false,
            autoplaySpeed: 500,
            autoWidth: false,
            autoHeight: false,
            center: true,
            navText: ['<div class="c-main-visual__nav is-left"><i class="fa fa-angle-left" aria-hidden="true"></i></div>','<div class="c-main-visual__nav is-right"><i class="fa fa-angle-right" aria-hidden="true"></i></div>'],
            responsive : {
              // breakpoint from 0 up
              0 : {
                stagePadding: 32,
              },
              // breakpoint from 750  up
              750 : {
                stagePadding: 64,
              },
              // breakpoint from 950 up
              950 : {
                stagePadding: 156,
              },
              1400 : {
                stagePadding: 312,
              }
            }
          });
        });
          //->カルーセル_レイヤー
          owls.imagesLoaded(function () {
            $('.c-main-visual-layer__carousel').owlCarousel({
              items: 1,
              margin: 0,
              dots: true,
              loop: true,
              nav: false,
              autoplayHoverPause: true,
              autoplay: true,
              autoplaySpeed: 500,
              autoWidth: false,
              autoHeight: false,
              center: true,
              navText: ['<img src="/wp-content/themes/ogura-enfant-html/dist/assets/images/icon-slider-prev.svg" />','<img src="/wp-content/themes/ogura-enfant-html/dist/assets/images/icon-slider-next.svg" />'],
            });
          });
          //->カード_カルーセル
          owls.imagesLoaded(function () {
              $('.c-front-banners__list.is-sm').owlCarousel({
                  margin: 34,
                  dots: true,
                  loop: true,
                  nav: true,
                  autoplayHoverPause: true,
                  autoplay: true,
                  autoplaySpeed: 500,
                  autoWidth: false,
                  autoHeight: false,
                  center: true,
                  navText: ['<img src="/wp-content/themes/ogura-enfant-html/dist/assets/images/icon-slider-prev.png" />','<img src="/wp-content/themes/ogura-enfant-html/dist/assets/images/icon-slider-next.png" />'],
                  responsive : {
                    // breakpoint from 0 up
                    0 : {
                      items: 1,
                      stagePadding: 50,
                      margin: 9
                    },
                    // breakpoint from 750 up
                    750 : {
                      items: 4,
                      stagePadding: 0
                    }
                  }
              });
          });
        owls.imagesLoaded(function () {
          $('.c-front-voice__list').owlCarousel({
            margin: 36,
            dots: true,
            loop: true,
            nav: true,
            autoplayHoverPause: true,
            autoplay: true,
            autoplaySpeed: 500,
            autoWidth: false,
            autoHeight: false,
            center: true,
            navText: ['<img src="/wp-content/themes/ogura-enfant-html/dist/assets/images/icon-slider-prev.png" />','<img src="/wp-content/themes/ogura-enfant-html/dist/assets/images/icon-slider-next.png" />'],
            responsive : {
              // breakpoint from 0 up
              0 : {
                items: 1,
                stagePadding: 30,
                margin: 40
              },
              // breakpoint from 750 up
              750 : {
                items: 2,
                center: false,
                stagePadding: 64
              },
              // breakpoint from 750 up
              1100 : {
                items: 3,
                stagePadding: 130
              }
            }
          });
        });
        owls.imagesLoaded(function () {
          $('.c-page-detail__slider').owlCarousel({
            items: 1,
            dots: true,
            loop: true,
            nav: false,
            autoplayHoverPause: true,
            autoplay: true,
            autoplaySpeed: 500,
            autoWidth: false,
            autoHeight: false,
            center: true,
            responsive: {
              // breakpoint from 0 up
              0: {},
              // breakpoint from 750 up
              750: {}
            }
          });
        });
        //->カード_カルーセル
        owls.imagesLoaded(function () {
          $('.c-top-banners__slider').owlCarousel({
            margin: 8,
            dots: true,
            loop: true,
            nav: true,
            autoplayHoverPause: true,
            autoplay: true,
            autoplaySpeed: 500,
            autoWidth: false,
            autoHeight: false,
            center: true,
            stagePadding: 84,
            navText: ['<img src="/wp-content/themes/ogura-enfant-html/dist/assets/images/icon-slider-prev.png" />', '<img src="/wp-content/themes/ogura-enfant-html/dist/assets/images/icon-slider-next.png" />'],
            responsive: {
              // breakpoint from 0 up
              0: {
                items: 1,
                stagePadding: 34,
              },
              // breakpoint from 750 up
              750: {
                items: 3,
              }
            }
          });
        });
      }
      function slickSlider() {
        var slider = '.js-slider';
        var thumbItem = '.js-thumb-item';
        var sliderMain = "";
        var thumb = '.js-thumb';

        $('.js-slider-main').each(function (i, elm) {
          var $slider_area = $(elm).parent();
          var $main_slide = $slider_area.find(".js-slider-main");
          var $thumb_slide = $slider_area.find(".js-thumb");


          // データ属性の数字を割り振る
          $thumb_slide.find('.js-thumb-item').each(function () {
            var index = $thumb_slide.find('.js-thumb-item').index(this);
            $(this).attr("data-index", index);
          });

          // 初期化
          $main_slide.on('init', function (slick) {
            $thumb_slide.find(".js-thumb-item:first-child").addClass('thumb-current');
          });

          // サムネイルをクリックした時スライダー切り替え
          $thumb_slide.find(".js-thumb-item").on('click', function () {
            var index = $(this).attr("data-index");
            $main_slide.slick("slickGoTo", index, false);
          });

          // サムネイル画像のカレントを切り替え
          $main_slide.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $thumb_slide.find(".js-thumb-item").removeClass("thumb-current");
            console.log(currentSlide);
            $thumb_slide.find('.js-thumb-item[data-index="' + nextSlide + '"]').addClass("thumb-current");
          });

          // オプション
          $main_slide.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            accessibility: false,
            dots: false,
            arrows: false,
            fade: true,
            responsive: [
              {
                breakpoint: 750,
                settings: {}
              },
            ]
          });
        });
      }

    // modal
    function popup() {
      var modal = $('.js-modal');
      modal.modaal({type: 'image'});


      var episode = $('.js-episode');
      episode.modaal();
    }




    $(function() {
      menuSlide();
      owlCarousel();
      slickSlider();
      popup();
    });
  }
}

window.GApp = new App();

var growApp = function () {
};

/******************************************************************************************
 *
 * 施設検索のGoogle map
 *
 *******************************************************************************************/
growApp.prototype.mapSearch = function () {

  if (typeof google === "undefined" || $('#shop-search').length === 0) {
    return false;
  }

  //初期化
  var map, toggle, markers = [];
  // 仮のjsonデータ
  var datalist = [
    {
      "name": "株式会社オグラ",
      "address": "東京都千代田区平河町1-6-2",
      "lat": "35.6825455",
      "lng": "139.7379042",
      "thumbnail": "img-shop-page-01.jpg",
      "url": "/shop-search/result/page/"
    },
    {
      "name": "株式会社オグラ2",
      "address": "東京都千代田区平河町1-6-2",
      "lat": "35.5825555",
      "lng": "139.3376042",
      "thumbnail": "img-shop-page-01.jpg",
      "url": "/shop-search/result/page/"
    },
    {
      "name": "株式会社オグラ3",
      "address": "東京都千代田区平河町1-6-2",
      "lat": "35.685555",
      "lng": "139.7386042",
      "thumbnail": "img-shop-page-01.jpg",
      "url": "/shop-search/result/page/"
    },
    {
      "name": "株式会社オグラ4",
      "address": "東京都千代田区平河町1-6-2",
      "lat": "35.655555",
      "lng": "139.7686042",
      "thumbnail": "img-shop-page-01.jpg",
      "url": "/shop-search/result/page/"
    },
    {
      "name": "株式会社オグラ5",
      "address": "東京都千代田区平河町1-6-2",
      "lat": "35.695555",
      "lng": "139.7186042",
      "thumbnail": "img-shop-page-01.jpg",
      "url": "/shop-search/result/page/"
    },
  ];
  if (window.facilitydata) {
    datalist = window.facilitydata;
  }

  var $spinner = $(".js-spinner");

  function showSpinner() {
    $spinner.fadeIn(300);
  }

  function hideSpinner() {
    $spinner.fadeOut(300);
  }

  //Mapの描画
  /*-------------------------------------------------------------------*/
  function initMap() {
    map = new google.maps.Map(document.getElementById('shop-search'), {
      center: {
        lat: 35.6825455,
        lng: 139.7379042,
      },
      zoom: 7,
      zoomControl: true,
      disableDoubleClickZoom: true,
      mapTypeControl: true,
      scaleControl: true,
      scrollwheel: false,
      panControl: true,
      streetViewControl: true,
      draggable: true,
      overviewMapControl: true,
      overviewMapControlOptions: {
        opened: false,
      },
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    });

    if (datalist.length < 2) {
      map.setZoom(12);
    } else {
      map.setZoom(7);
    }
  }

  //JSONデータ分、ピンをさして、ウィンドウを作成する
  /*-------------------------------------------------------------------*/
  function addMarkerPosition() {
    var $_html = null;

    var markerBounds = new google.maps.LatLngBounds();
    //順番に処理開始
    for (var i = 0; i < datalist.length; i++) {
      var latlng = {
        lat: datalist[i]['lat'] - 0,
        lng: datalist[i]['lng'] - 0,
      };

      //吹き出しをセット
      $_html = $('<div><div class="c-googletooltip is-tips">' +
        '<div class="c-googletooltip__overflow"><img class="c-googletooltip__image" src="' + datalist[i].thumbnail + '" alt="' + datalist[i].name + '"></div>' +
        '<div class="c-googletooltip__name">' + datalist[i].name + '</div>' +
        '<div class="c-googletooltip__text">' + datalist[i].address + '</div>' +
        '<a class="c-button is-xs" href="' + datalist[i].url + '">詳細を見る</a></div></div>');
      var infowindow = new google.maps.InfoWindow({
        content: $_html.html(),
        disableAutoPan: false
      });

      //マーカーをセット
      var marker = new google.maps.Marker({
        position: latlng,
        map: map,
      });

      markers[i] = marker;
      markers[i]["infowindow"] = infowindow;

      marker.setMap(map);
      markerBounds.extend(latlng);

      // クリック時に外のinfoWindowをすべて閉じて開く
      google.maps.event.addListener(marker, 'click', function () {
        if (0 === toggle) {
          for (var i = 0; i < markers.length; i++) {
            var currentMaker = markers[i];
            currentMaker['infowindow'].close();
          }

          infowindow.setContent(this.infowindow.content);
          infowindow.open(map, this);
          map.setCenter(this.getPosition());
          toggle = 1;

        } else {
          infowindow.close();
          toggle = 0;
          infowindow.setContent(this.infowindow.content);
          infowindow.open(map, this);
          map.setCenter(this.getPosition());
        }
      });


      //座標を配列に格納
      var latlng_data = [];
      latlng_data.push(latlng);
    }

    map.fitBounds(markerBounds);

    if (datalist.length === 1) {
      var listener = google.maps.event.addListener(map, "idle", function () {
        map.setZoom(18);
        google.maps.event.removeListener(listener);
      });
    } else {
      map.fitBounds(markerBounds);
    }

    //センターへ移動
    // google.maps.setCenter(new google.maps.LatLng(latlng_data[0].lat, latlng_data[0].lng ));
  }

  //現在地検索
  /*-------------------------------------------------------------------*/
  function clickCurrentPos() {
    var currentPos;
    var $btnParent = $('.js-search-currentplace-btn');
    var $btn = $('.js-search-currentplace-btn');
    if ($btn.length === 0) {
      return false;
    }

    $btn.on("click", $btn, function (e) {
      e.preventDefault();
      showSpinner();
      //オプション
      /*-------------------------------------------*/
      var options = {
        enableHighAccuracy: true,
        maximumAge: Infinity,
        timeout: 60000
      }

      //現在地取得に失敗した場合の処理
      /*-------------------------------------------*/
      function error(err) {
        alert("SSLが有効化されていない、もしくはお使いの端末の位置情報サービスが無効になっているか対応していないため、現在ご利用いただけません。今しばらくお待ち下さいませ。");
        // console.warn(`ERROR(${err.code}): ${err.message}`);
      }

      //現在地取得に成功した場合の処理
      /*-------------------------------------------*/
      function success(pos) {

        hideSpinner();
        /*-------------------------------------------*/
        //Google mapの描画
        /*-------------------------------------------*/

        //初期化
        var closest;

        // 現在位置にピンをたてる
        currentPos = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
        var currentMarker = new google.maps.Marker({
          flat: true,
          map: map,
          optimized: false,
          title: '現在地',
          position: currentPos,
          icon: '/wp-content/themes/ogura-enfant-html/dist/assets/images/icon-map-currentpos.png', //新しく指定
        });

        //マーカーをマップに配置
        currentMarker.setMap(map);

        //マップのセンターを現在位置に移動
        for (var mm = 0; mm < markers.length; mm++) {
          var _marker = markers[mm];

          //2点間の距離を求めると各施設の距離を比較する
          var distance = google.maps.geometry.spherical.computeDistanceBetween(_marker.getPosition(), currentMarker.getPosition());
          if (!closest || closest.distance > distance) {
            closest = {
              marker: _marker,
              distance: distance
            }
          }
        }

        //もっとも近いところをセンターにしてピンを立てる
        if (closest) {
          google.maps.event.trigger(closest.marker, 'click');
          map.setZoom(9);
          map.setCenter(closest.marker.getPosition());
          closest.marker.infowindow.open(map, closest.marker);
        }
      }

      //現在地検索処理
      window.navigator.geolocation.getCurrentPosition(success, error, options);

      $(this).off('click');

    });
  }

  //Mapの描画とマーカーピンをさして、ウィンドウを作成する
  function runInitMap() {
    initMap();
    addMarkerPosition();
    clickCurrentPos();
  }

  runInitMap();
}

/******************************************************************************************
 *
 * 現在地から探すを2回目以降反応させない
 *
 *******************************************************************************************/
growApp.prototype.clickCurrentPosCancel = function () {
  var $btn = $('.js-search-currentplace-btn');
  var count = 0;

  if ($btn.length === 0) {
    return false;
  }

  $btn.on('click', function (e) {
    count++;
    if (count > 0) {
      e.preventDefault();
    }
  });
}

$(function () {
  var app = new growApp();
  app.mapSearch();
  app.clickCurrentPosCancel();
});
